import React from "react"
import * as URLConfig from "../../config/domain";

interface IHome {}

export const Home = (props: IHome) => {
	React.useEffect(() => {
		// window.location.replace(URLConfig.config.rootUrl);
		return () => {};
	}, []);
	return (<></>)
	
};
